/*
 * @Author: chengyu
 * @Date: 2022-10-27 03:02:16
 * @Description: 添加debug信息，便于调试
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getContext, getContextEnv } from '../config';
import { CacheTypeEnum, ContextEnvEnum } from '../enums';
import { cacheEmit } from './emitter';
import { isNumber } from './is';
import { mapError, mapLog } from './logger';
export function showModal(_a) {
    var title = _a.title, content = _a.content, cancelText = _a.cancelText, _b = _a.confirmText, confirmText = _b === void 0 ? '确认' : _b, cancel = _a.cancel, confirm = _a.confirm;
    var context = getContext();
    var contextEnv = getContextEnv();
    var options = {
        title: title,
        content: content,
        cancelText: cancelText,
        confirmText: confirmText,
        success: function (res) {
            if (res.confirm) {
                if (confirm)
                    confirm();
            }
            else if (res.cancel) {
                if (cancel)
                    cancel();
            }
            else {
                // 取消
                if (cancel)
                    cancel();
            }
        },
    };
    switch (contextEnv) {
        case ContextEnvEnum.ALIPAY:
            context === null || context === void 0 ? void 0 : context.confirm(__assign(__assign({}, options), { confirmButtonText: confirmText, cancelButtonText: cancelText }));
            break;
        case ContextEnvEnum.WECHAT:
            context === null || context === void 0 ? void 0 : context.showModal(options);
            break;
        case ContextEnvEnum.TARO:
            context === null || context === void 0 ? void 0 : context.showModal(options);
            break;
        case ContextEnvEnum.BROWSER:
            mapLog(title, [content]);
            break;
        // @ts-ignore
        case ContextEnvEnum.NODE:
            mapLog(title, [content]);
            break;
    }
}
/**
 * 弱提示
 * 在到达设定的显示时间后自动消失
 */
export function showToast(title) {
    var _a;
    try {
        var context_1 = getContext();
        var contextEnv = getContextEnv();
        var config_1 = {
            title: title,
            duration: 2000,
        };
        var toastFn = (_a = {},
            _a[ContextEnvEnum.ALIPAY] = function () {
                return context_1 === null || context_1 === void 0 ? void 0 : context_1.showToast(__assign(__assign({}, config_1), { content: title }));
            },
            _a[ContextEnvEnum.WECHAT] = function () { return context_1 === null || context_1 === void 0 ? void 0 : context_1.showToast(config_1); },
            _a[ContextEnvEnum.TARO] = function () { return context_1 === null || context_1 === void 0 ? void 0 : context_1.showToast(config_1); },
            _a[ContextEnvEnum.BROWSER] = function () {
                // nothing
            },
            _a);
        var fn = toastFn[contextEnv];
        if (typeof fn === 'function')
            fn();
    }
    catch (e) {
        mapError('showToast', e);
    }
}
/**
 * 逆地理缓存调试辅助弹窗
 */
export function debugRgcShowModal(_a) {
    var cancel = _a.cancel, cacheCounts = _a.cacheCounts, ttl = _a.ttl, start = _a.start, limitCount = _a.limitCount, currentCount = _a.currentCount, precision = _a.precision, key = _a.key;
    var time = '', count = '';
    if (isNumber(start) && isNumber(ttl)) {
        // 剩余时间
        // @ts-ignore
        time = "".concat((start + ttl - new Date().getTime()) / 1000, "s");
    }
    if (isNumber(limitCount) && isNumber(currentCount)) {
        // 剩余次数
        // @ts-ignore
        count = "".concat(limitCount - currentCount, "\u6B21");
    }
    cacheEmit(CacheTypeEnum.geo, key, undefined, {
        // @ts-ignore
        fetchOptions: { method: 'reGeoCodingSearch', serviceType: 'unknown' },
        geoHashCacheInfo: { geoHashCacheType: precision, cacheCounts: cacheCounts, time: time, count: count },
    });
    showModal({
        title: '逆地理缓存提示(测试)',
        cancelText: '清空缓存',
        content: "\n    \u547D\u4E2D => ".concat(precision, "\n    \u7F13\u5B58key: ").concat(key, "\n    \u7F13\u5B58\u603B\u6761\u6570\uFF1A").concat(cacheCounts, "\n    \u5269\u4F59\u65F6\u95F4\uFF1A").concat(time || '无', "\n    \u5269\u4F59\u6B21\u6570\uFF1A").concat(count || '无', "\n"),
        cancel: cancel,
    });
}
//# sourceMappingURL=data:application/json;base64,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